<template>
    <div class="date-range">
        <a-range-picker 
            class="dashboard-date-range" 
            :format="dateFormat" 
            @change="onToDateChange"
            :value="dates" 
        />
    </div>
</template>

<script>
import {ref, computed, watch} from '@vue/composition-api'
import moment from 'moment'
import {useRouter} from '../../../../../core/hooks'

export default {
    name: 'DatePicker',
    setup(props, context){

        const {route, router} = useRouter();
        const dateFormat = 'DD/MM/YYYY';

        const dates = ref([])

        watch(route, route => {
            const dateRange = route.query.filters && JSON.parse(route.query.filters).dateRange ?
                        JSON.parse(route.query.filters).dateRange.map(item => new Date(item)) :
                        null

            dates.value = dateRange ? [
                            moment.utc(dateRange[0], dateFormat),
                            moment.utc(dateRange[1], dateFormat)
                        ] : []
        }, {immediate: true})


        const onToDateChange =  x => {
            const dates = (x && x.length) ? [x[0].toDate(), x[1].toDate()] : undefined;
            context.emit('setFilter', 'dateRange', dates)
        }

        return {
            dates,
            dateFormat,
            onToDateChange
        }
    }
}
</script>
<style lang="scss" scoped>
div.date-range {
    width: 228px;
}

</style>